import "./Dashboard.02d5a840.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6f40"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6f40"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dLCGn", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = {
        year: 0,
        month: 1,
        day: 2,
        hour: 3,
        minute: 4,
        second: 5
    }, e = {};
    return function(n, i, o) {
        var r, a = function(t, n, i) {
            void 0 === i && (i = {});
            var o = new Date(t), r = function(t, n) {
                void 0 === n && (n = {});
                var i = n.timeZoneName || "short", o = t + "|" + i, r = e[o];
                return r || (r = new Intl.DateTimeFormat("en-US", {
                    hour12: !1,
                    timeZone: t,
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    timeZoneName: i
                }), e[o] = r), r;
            }(n, i);
            return r.formatToParts(o);
        }, u = function(e, n) {
            for(var i = a(e, n), r = [], u = 0; u < i.length; u += 1){
                var f = i[u], s = f.type, m = f.value, c = t[s];
                c >= 0 && (r[c] = parseInt(m, 10));
            }
            var d = r[3], l = 24 === d ? 0 : d, h = r[0] + "-" + r[1] + "-" + r[2] + " " + l + ":" + r[4] + ":" + r[5] + ":000", v = +e;
            return (o.utc(h).valueOf() - (v -= v % 1e3)) / 6e4;
        }, f = i.prototype;
        f.tz = function(t, e) {
            void 0 === t && (t = r);
            var n, i = this.utcOffset(), a = this.toDate(), u = a.toLocaleString("en-US", {
                timeZone: t
            }), f = Math.round((a - new Date(u)) / 1e3 / 60), s = 15 * -Math.round(a.getTimezoneOffset() / 15) - f;
            if (!Number(s)) n = this.utcOffset(0, e);
            else if (n = o(u, {
                locale: this.$L
            }).$set("millisecond", this.$ms).utcOffset(s, !0), e) {
                var m = n.utcOffset();
                n = n.add(i - m, "minute");
            }
            return n.$x.$timezone = t, n;
        }, f.offsetName = function(t) {
            var e = this.$x.$timezone || o.tz.guess(), n = a(this.valueOf(), e, {
                timeZoneName: t
            }).find(function(t) {
                return "timezonename" === t.type.toLowerCase();
            });
            return n && n.value;
        };
        var s = f.startOf;
        f.startOf = function(t, e) {
            if (!this.$x || !this.$x.$timezone) return s.call(this, t, e);
            var n = o(this.format("YYYY-MM-DD HH:mm:ss:SSS"), {
                locale: this.$L
            });
            return s.call(n, t, e).tz(this.$x.$timezone, !0);
        }, o.tz = function(t, e, n) {
            var i = n && e, a = n || e || r, f = u(+o(), a);
            if ("string" != typeof t) return o(t).tz(a);
            var s = function(t, e, n) {
                var i = t - 60 * e * 1e3, o = u(i, n);
                if (e === o) return [
                    i,
                    e
                ];
                var r = u(i -= 60 * (o - e) * 1e3, n);
                return o === r ? [
                    i,
                    o
                ] : [
                    t - 60 * Math.min(o, r) * 1e3,
                    Math.max(o, r)
                ];
            }(o.utc(t, i).valueOf(), f, a), m = s[0], c = s[1], d = o(m).utcOffset(c);
            return d.$x.$timezone = a, d;
        }, o.tz.guess = function() {
            return Intl.DateTimeFormat().resolvedOptions().timeZone;
        }, o.tz.setDefault = function(t) {
            r = t;
        };
    };
});

});


var $h8sKa = parcelRequire("h8sKa");

var $6lxfX = parcelRequire("6lxfX");

var $gngdn = parcelRequire("gngdn");

var $gogTx = parcelRequire("gogTx");

var $dLCGn = parcelRequire("dLCGn");

var $3CfG2 = parcelRequire("3CfG2");
(0, (/*@__PURE__*/$parcel$interopDefault($gngdn))).extend((0, (/*@__PURE__*/$parcel$interopDefault($gogTx))));
(0, (/*@__PURE__*/$parcel$interopDefault($gngdn))).extend((0, (/*@__PURE__*/$parcel$interopDefault($dLCGn))));
let $ea54b07b7d10d2c5$var$accountPlanId = 1;
const $ea54b07b7d10d2c5$var$renderPlan = ()=>{
    $ea54b07b7d10d2c5$var$accountPlanId = location.search.split('=')[1] ?? '1';
    let plan = (0, $3CfG2.PLANS)[$ea54b07b7d10d2c5$var$accountPlanId];
    if (!plan) return;
    const planName = document.querySelector('.plan-name');
    const pretaxAmount = document.querySelector('.plan-pre');
    const tax = document.querySelector('.plan-tax');
    const totalAmount = document.querySelector('.plan-total');
    planName.textContent = 'Plan ' + plan.name;
    pretaxAmount.textContent = plan.pretaxAmount;
    tax.textContent = plan.tax;
    totalAmount.textContent = plan.totalAmount;
    if ($ea54b07b7d10d2c5$var$accountPlanId === '1') {
        const payWay = document.querySelector('.pay-way');
        payWay.classList.remove('d-none');
        payWay.addEventListener('input', (_)=>{
            const currentPayWay = payWay.querySelector('input:checked');
            const payWayRequestEl = document.querySelector('.pay-way-request');
            if (currentPayWay.value === 'monthly') {
                $ea54b07b7d10d2c5$var$accountPlanId = '5';
                planName.textContent = 'Plan ' + plan.name;
                payWayRequestEl.classList.add('d-none');
                const payMethodInput = document.querySelector('input[name="payMethod"]');
                payMethodInput.click();
            } else {
                $ea54b07b7d10d2c5$var$accountPlanId = '1';
                planName.textContent = 'Plan ' + plan.name;
                payWayRequestEl.classList.remove('d-none');
            }
            plan = (0, $3CfG2.PLANS)[$ea54b07b7d10d2c5$var$accountPlanId];
            pretaxAmount.textContent = plan.pretaxAmount;
            tax.textContent = plan.tax;
            totalAmount.textContent = plan.totalAmount;
        });
    }
};
let $ea54b07b7d10d2c5$var$ui = null;
let $ea54b07b7d10d2c5$var$fincode = null;
let $ea54b07b7d10d2c5$var$currentCardId = null;
const $ea54b07b7d10d2c5$var$btnAddCard = document.querySelector('.btn-add-card');
const $ea54b07b7d10d2c5$var$btnViewList = document.querySelector('.btn-view-list');
const $ea54b07b7d10d2c5$var$tipAddCardEl = document.querySelector('.tip-add-card');
const $ea54b07b7d10d2c5$var$btnNewCard = document.querySelector('.btn-new-card');
const $ea54b07b7d10d2c5$var$cardList = document.querySelector('.card-list');
const $ea54b07b7d10d2c5$var$cardForm = document.querySelector('.card-form');
const $ea54b07b7d10d2c5$var$submitBtn = document.querySelector('#submit');
const $ea54b07b7d10d2c5$var$addNewCard = async (callback)=>{
    $ea54b07b7d10d2c5$var$btnAddCard.disabled = true;
    $ea54b07b7d10d2c5$var$submitBtn.disabled = true;
    $ea54b07b7d10d2c5$var$ui.getFormData().then((data)=>{
        if (!data.cardNo) {
            new (0, $6lxfX.default)().toast('warning', "\u30AB\u30FC\u30C9\u756A\u53F7\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044", false, {
                callback: ()=>{
                    $ea54b07b7d10d2c5$var$btnAddCard.disabled = false;
                    $ea54b07b7d10d2c5$var$submitBtn.disabled = false;
                }
            });
            return;
        }
        if (!data.expire) {
            new (0, $6lxfX.default)().toast('warning', "\u6709\u52B9\u671F\u9650\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044", false, {
                callback: ()=>{
                    $ea54b07b7d10d2c5$var$btnAddCard.disabled = false;
                    $ea54b07b7d10d2c5$var$submitBtn.disabled = false;
                }
            });
            return;
        }
        $ea54b07b7d10d2c5$var$fincode.tokens({
            card_no: data.cardNo,
            expire: data.expire
        }, function(status, response) {
            if (200 === status) // リクエスト正常時の処理
            (0, $h8sKa.request)('portal/trade/cards', {
                token: response.list[0].token
            }, true, 'POST').then((res)=>{
                if (res.code === 200 && res.data.status !== 500) {
                    if (callback) {
                        (0, $h8sKa.request)('portal/trade/cards', null, true, 'GET').then((res)=>{
                            if (res.code === 200 && res.data) {
                                $ea54b07b7d10d2c5$var$currentCardId = res.data[0].id;
                                callback();
                            }
                        });
                        return;
                    }
                    new (0, $6lxfX.default)().toast('success', "\u30AB\u30FC\u30C9\u3092\u767B\u9332\u3057\u307E\u3057\u305F", false, {
                        callback: ()=>{
                            $ea54b07b7d10d2c5$var$btnViewList.classList.add('d-none');
                            $ea54b07b7d10d2c5$var$tipAddCardEl.classList.add('d-none');
                            $ea54b07b7d10d2c5$var$btnAddCard.classList.add('d-none');
                            $ea54b07b7d10d2c5$var$btnAddCard.disabled = false;
                            $ea54b07b7d10d2c5$var$submitBtn.disabled = false;
                            $ea54b07b7d10d2c5$var$btnNewCard.classList.remove('d-none');
                            $ea54b07b7d10d2c5$var$cardList.classList.remove('d-none');
                            $ea54b07b7d10d2c5$var$cardForm.innerHTML = '';
                            $ea54b07b7d10d2c5$var$renderCardList();
                        }
                    });
                } else {
                    $ea54b07b7d10d2c5$var$btnAddCard.disabled = false;
                    $ea54b07b7d10d2c5$var$submitBtn.disabled = false;
                    // failed to add credit card, please try again
                    new (0, $6lxfX.default)().toast('danger', res.message, false, {
                        callback: ()=>{
                            if (res.code === 781) window.location.href = '/admin.html#/enterprise';
                        }
                    });
                }
            });
            else {
                // リクエストエラー時の処理
                new (0, $6lxfX.default)().toast('danger', "\u30AB\u30FC\u30C9\u60C5\u5831\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044");
                $ea54b07b7d10d2c5$var$btnAddCard.disabled = false;
                $ea54b07b7d10d2c5$var$submitBtn.disabled = false;
            }
        }, function() {
            // 通信エラー処理
            new (0, $6lxfX.default)().toast('danger', "\u30AB\u30FC\u30C9\u60C5\u5831\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044");
            $ea54b07b7d10d2c5$var$btnAddCard.disabled = false;
            $ea54b07b7d10d2c5$var$submitBtn.disabled = false;
        });
    }).catch((_)=>{
        new (0, $6lxfX.default)().toast('danger', "\u30AB\u30FC\u30C9\u60C5\u5831\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044");
        $ea54b07b7d10d2c5$var$btnNewCard.disabled = false;
        $ea54b07b7d10d2c5$var$submitBtn.disabled = false;
    });
};
const $ea54b07b7d10d2c5$var$renderCardList = async ()=>{
    if (!$ea54b07b7d10d2c5$var$cardList) return;
    $ea54b07b7d10d2c5$var$cardList.innerHTML = `
    <table
      class="table align-middle"
      style="margin-top: 1rem; color: #16191e; font-size: 0.875rem;min-width: 880px;"
    >
      <thead style="background-color: #f5f7fa">
        <tr>
          <th scope='col' style='width: 1rem'></th>
          <th scope="col">\u{30AF}\u{30EC}\u{30B8}\u{30C3}\u{30C8}\u{30AB}\u{30FC}\u{30C9}\u{756A}\u{53F7}</th>
          <th scope="col">\u{6709}\u{52B9}\u{671F}\u{9650}</th>
          <th scope="col">\u{6700}\u{7D42}\u{66F4}\u{65B0}\u{65E5}\u{6642}</th>
        </tr>
      </thead>
      <tbody class="card-list-body"></tbody>
    </table>
  `;
    const listRes = await (0, $h8sKa.request)('portal/trade/cards', null, true, 'GET');
    if (listRes.code === 200 && listRes.data?.length === 0) {
        document.querySelector('.tip-add-card').textContent = "\u5DE6\u5074\u306B\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9\u60C5\u5831\u3092\u5165\u529B\u3057\u3001\u53F3\u5074\u306E\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u652F\u6255\u3044\u3092\u884C\u3063\u3066\u304F\u3060\u3055\u3044\u3002";
        $ea54b07b7d10d2c5$var$btnNewCard.click();
        document.querySelector('.btn-add-card').classList.add('d-none');
        document.querySelector('.btn-view-list').classList.add('d-none');
        $ea54b07b7d10d2c5$var$submitBtn?.addEventListener('click', async (e)=>{
            e.preventDefault();
            $ea54b07b7d10d2c5$var$submitBtn.disabled = true;
            const payMethodInput = document.querySelector('input[name="payMethod"]:checked');
            if (payMethodInput.value === 'request') {
                await $ea54b07b7d10d2c5$var$submitPayment();
                return;
            }
            await $ea54b07b7d10d2c5$var$addNewCard(async ()=>{
                await $ea54b07b7d10d2c5$var$submitPayment();
            });
        });
        return;
    }
    if (listRes.code === 200 && listRes.data) listRes.data.forEach((item)=>{
        const tr = document.createElement('tr');
        tr.innerHTML = `
        <td>
         <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="listCurrentCard"
              id="${item.id}"
            />
          </div>
        </td>
        <td>${item.card_no}</td>
        <td>${item.expire.slice(0, 2) + '/' + item.expire.slice(2)}</td>
        <td>${(0, (/*@__PURE__*/$parcel$interopDefault($gngdn))).tz(item.created, 'Asia/Tokyo').utc().tz((0, (/*@__PURE__*/$parcel$interopDefault($gngdn))).tz.guess()).format('YYYY-MM-DD HH:mm')}</td>
      `;
        $ea54b07b7d10d2c5$var$cardList.querySelector('.card-list-body').appendChild(tr);
    });
    if (listRes.data.length === 5) $ea54b07b7d10d2c5$var$btnNewCard.classList.add('d-none');
    $ea54b07b7d10d2c5$var$submitBtn?.addEventListener('click', async (e)=>{
        e.preventDefault();
        $ea54b07b7d10d2c5$var$submitBtn.disabled = true;
        await $ea54b07b7d10d2c5$var$submitPayment();
    });
    document.querySelector('.credit-card-region').classList.remove('visually-hidden');
};
const $ea54b07b7d10d2c5$var$preloadScripts = (callback)=>{
    // append fincode scripts
    const isProd = true;
    const host = isProd ? 'https://js.fincode.jp/' : 'https://js.test.fincode.jp/';
    const scriptUrls = [
        'v1/fincode.js',
        'js/app.js',
        'js/chunk-vendors.js',
        'js/0.js',
        'js/2.js'
    ];
    scriptUrls.forEach((url, index)=>{
        if (index === 0) {
            const script = document.createElement('script');
            script.src = host + url;
            document.querySelector('main').appendChild(script);
            script.onload = ()=>{
                callback();
            };
        } else {
            //  preload
            const obj = document.createElement('object');
            obj.data = host + url;
            obj.type = 'text/javascript';
            obj.width = '0';
            obj.height = '0';
            document.head.appendChild(obj);
        }
    });
};
const $ea54b07b7d10d2c5$var$renderCardForm = ()=>{
    $ea54b07b7d10d2c5$var$btnNewCard?.classList.remove('d-none');
    $ea54b07b7d10d2c5$var$btnNewCard?.addEventListener('click', (e)=>{
        e.preventDefault();
        if (!$ea54b07b7d10d2c5$var$cardForm) return;
        $ea54b07b7d10d2c5$var$cardForm.innerHTML = `
      <form id="fincode-form" onsubmit="return false">
        <div id="fincode">
      </form>`;
        $ea54b07b7d10d2c5$var$fincode = Fincode("prod" === 'prod' ? 'p_prod_NmE5OTNlMjgtNTcyZC00ZTY2LThhZWYtYjViNWE4NjFjNDE4M2JmNWExODAtYzhhMi00OTE3LThkYjgtMDcxYzYzZjljNmUzc18yMjExMDI2MTQ5Mg' : 'p_test_NTRjOWY0MWUtOTU2MS00NzNiLTljMDUtYjVlZDBiMDc1ZTJkZGZkZjJlM2ItNmNjNS00Y2UzLThlYTYtZTQ0MjA2ZjM4ODUzc18yMjExMDI2MzY2Nw');
        $ea54b07b7d10d2c5$var$ui = $ea54b07b7d10d2c5$var$fincode.ui({
            layout: 'vertical'
        });
        $ea54b07b7d10d2c5$var$ui.create('tokens', {
            layout: 'vertical',
            colorPlaceHolder: 'gray',
            expireMonth: 'MM',
            expireYear: 'YY'
        });
        $ea54b07b7d10d2c5$var$ui.mount('fincode', (0, $h8sKa.isMobile)() ? '250' : '350');
        const cardList = document.querySelector('.card-list');
        $ea54b07b7d10d2c5$var$btnNewCard.classList.add('d-none');
        cardList.classList.add('d-none');
        document.querySelector('.credit-card-region').classList.remove('visually-hidden');
        $ea54b07b7d10d2c5$var$cardForm.classList.remove('position-absolute');
        cardList.style.zIndex = 'initial';
        $ea54b07b7d10d2c5$var$btnAddCard.classList.remove('d-none');
        $ea54b07b7d10d2c5$var$btnAddCard.onclick = (_)=>{
            $ea54b07b7d10d2c5$var$btnAddCard.disabled = true;
            $ea54b07b7d10d2c5$var$addNewCard();
        };
        $ea54b07b7d10d2c5$var$btnViewList.classList.remove('d-none');
        $ea54b07b7d10d2c5$var$tipAddCardEl.classList.remove('d-none');
        $ea54b07b7d10d2c5$var$btnViewList.onclick = (_)=>{
            $ea54b07b7d10d2c5$var$btnAddCard.classList.add('d-none');
            $ea54b07b7d10d2c5$var$btnViewList.classList.add('d-none');
            $ea54b07b7d10d2c5$var$tipAddCardEl.classList.add('d-none');
            $ea54b07b7d10d2c5$var$btnNewCard.classList.remove('d-none');
            cardList.classList.remove('d-none');
            $ea54b07b7d10d2c5$var$cardForm.innerHTML = '';
        };
    });
};
const $ea54b07b7d10d2c5$var$submitPayment = async ()=>{
    const submitBtn = document.querySelector('#submit');
    submitBtn.disabled = true;
    $ea54b07b7d10d2c5$var$currentCardId = document.querySelector('input[name="listCurrentCard"]:checked')?.id ?? $ea54b07b7d10d2c5$var$currentCardId;
    const payMethodInput = document.querySelector('input[name="payMethod"]:checked');
    const paymentMethod = payMethodInput.value === 'request' ? 2 : 1;
    if (!$ea54b07b7d10d2c5$var$currentCardId && paymentMethod === 1) {
        new (0, $6lxfX.default)().toast('warning', "\u30AB\u30FC\u30C9\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044", false, {
            callback: ()=>{
                submitBtn.disabled = false;
            }
        });
        return;
    }
    if (paymentMethod === 2) {
        const currentCustomerRes = await (0, $h8sKa.request)('portal/customers', null, true, 'GET');
        if (currentCustomerRes?.data?.thirdPartyStatus === 2) {
            const statusModalEl = document.getElementById('statusModal');
            const companyEl = statusModalEl.querySelector('.company');
            companyEl.innerHTML = currentCustomerRes?.data?.customerName;
            const myModal = new mdb.Modal(document.getElementById('statusModal'));
            myModal.show();
            submitBtn.disabled = false;
            return;
        }
    }
    (0, $h8sKa.request)('portal/accountPlanOrder', {
        accountPlanId: $ea54b07b7d10d2c5$var$accountPlanId,
        paymentMethod: paymentMethod,
        fincodeCardId: $ea54b07b7d10d2c5$var$currentCardId
    }).then((res)=>{
        if (res.code === 200) {
            new (0, $6lxfX.default)().toast('success', "\u6CE8\u6587\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F", false, {
                callback: ()=>{
                    window.location.href = '/admin.html#/orders';
                }
            });
            return;
        }
        if (res.code === 740) {
            // User's account plan is already expired
            // jump to dashboard
            new (0, $6lxfX.default)().toast('danger', res.message, false, {
                callback: ()=>{
                    window.location.href = '/admin.html';
                }
            });
            return;
        }
        new (0, $6lxfX.default)().toast('danger', res.message, false, {
            callback: ()=>{
                window.location.href = '/admin.html#/enterprise';
            }
        });
    }).catch((_)=>{
        submitBtn.disabled = false;
    });
};
const $ea54b07b7d10d2c5$export$18f430e15f133060 = async ()=>{
    try {
        if (!location.href.includes('/payment')) return;
        const currentCustomerRes = await (0, $h8sKa.request)('portal/customers', null, true, 'GET');
        if (currentCustomerRes.code === 200 && currentCustomerRes.data && currentCustomerRes.data.myDeptType === 2) {
            const dashboardBodyEl = document.querySelector('.dashboard-body');
            dashboardBodyEl.classList.add('d-none');
            document.querySelector('main').innerHTML = '';
            document.querySelector('header').innerHTML = '';
            const modalEl = document.getElementById('permissionModal');
            const modalBodyEl = modalEl.querySelector('.permission-modal-body');
            modalBodyEl.textContent = `\u{73FE}\u{5728}\u{3001}\u{30A8}\u{30FC}\u{30B8}\u{30A7}\u{30F3}\u{30C8}\u{3092}\u{901A}\u{3057}\u{3066}\u{30D1}\u{30C3}\u{30B1}\u{30FC}\u{30B8}\u{3092}\u{8CFC}\u{5165}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{3059}\u{304C}\u{3001}\u{95A2}\u{9023}\u{4E8B}\u{9805}\u{306B}\u{3064}\u{3044}\u{3066}\u{306F}${currentCustomerRes.data?.agentName ?? ''}\u{306B}\u{304A}\u{554F}\u{3044}\u{5408}\u{308F}\u{305B}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}`;
            const myModal = new mdb.Modal(document.getElementById('permissionModal'));
            myModal.show();
            modalEl.addEventListener('hidden.mdb.modal', (e)=>{
                window.location.href = '/admin.html';
            });
            return;
        }
        $ea54b07b7d10d2c5$var$preloadScripts(async ()=>{
            $ea54b07b7d10d2c5$var$renderCardForm();
            await $ea54b07b7d10d2c5$var$renderCardList();
        });
        $ea54b07b7d10d2c5$var$renderPlan();
        const payMethodRadios = document.querySelector('.pay-method-radios');
        payMethodRadios?.addEventListener('click', (e)=>{
            const value = e.target.value;
            if (value === 'request') {
                document.querySelector('.credit-card-region').classList.add('d-none');
                document.querySelector('.request-book-region').classList.remove('d-none');
                return;
            }
            if (value === 'credit-card') {
                document.querySelector('.credit-card-region').classList.remove('d-none');
                document.querySelector('.request-book-region').classList.add('d-none');
            }
        });
    } catch (err) {
        console.log(err);
    }
};


//# sourceMappingURL=ScanatWeb.3fa8819a.js.map
